import type WebSocket from 'ws';
import { sendWsMessage } from './create-ws-bridge.js';
import { discoverGitRepos } from '../git/discover-repos.js';
import type { LogFn } from '../log.js';

/**
 * Discover git repos (CWD + immediate child dirs) and report them to the
 * bridge WebSocket. Runs asynchronously via setImmediate so it doesn't
 * block the connection handshake.
 */
export function reportGitRepos(getWs: () => WebSocket | null, log: LogFn): void {
  setImmediate(() => {
    discoverGitRepos()
      .then((repos) => {
        if (repos.length > 0) {
          const socket = getWs();
          if (socket) {
            sendWsMessage(socket, {
              type: 'git_repos',
              repos: repos.map((r) => ({ absolutePath: r.absolutePath, remoteUrl: r.remoteUrl })),
            });
          }
        }
      })
      .catch((err) => {
        log(
          `[Bridge service] Git repository discovery failed: ${err instanceof Error ? err.message : String(err)}`,
        );
      });
  });
}
